export class ResponseModel {
  public status: boolean;
  public message: string;
  public data: any;

  constructor(json) {
    this.status = json.status;
    this.message = json.message;
    this.data = json.data;
  }
}
